import { useQuery } from '@tanstack/react-query';
import { EmailDraft } from '../chat/types';

export type EmailDraftResponse = {
  id: string;
  recipientEmail: string;
  subject: string;
  body: string;
  attachment?: { fileId: number; fileName: string } | null;
  sentAt?: string | null;
  savedToOutlookAt?: string | null;
  createdAt: string | null;
};

export function toEmailDraft(draft: EmailDraftResponse): EmailDraft {
  return {
    draftId: draft.id,
    to: draft.recipientEmail,
    subject: draft.subject,
    body: draft.body,
    attachment: draft.attachment ?? null,
    sentAt: draft.sentAt ?? null,
    savedToOutlookAt: draft.savedToOutlookAt ?? null,
  };
}

export function useConversationEmailDrafts(conversationId: string | undefined, enabled: boolean) {
  const { data, isError } = useQuery<EmailDraftResponse[]>({
    queryKey: ['conversations', conversationId, 'email-drafts'],
    enabled: enabled && !!conversationId,
    // A failed rehydrate is never surfaced as an error state; the next poll retries it.
    retry: false,
  });
  return { emailDrafts: isError ? [] : (data ?? []) };
}
